<shared-modal width="320px">
  <!-- header -->
  <h2 slot="header" class="flex">
    Conectar número
    <span
      class="material-symbols-rounded cursor-pointer ml-auto"
      (click)="sharedService.closeModal(route)"
      >close</span
    >
  </h2>

  <!-- body -->
  @if (qr$() | async; as qr) {
    <qrcode class="grid-overlap mx-auto" [qrdata]="qr" [width]="200"></qrcode>
  } @else {
    <!-- TODO: add overlap content -->
    <ng-template #overlap>Carregando...</ng-template>
  }

  <p>Escaneie o código acima no WhatsApp para ativar a sessão.</p>
</shared-modal>
